import { defaultWidth, defaultHeight } from "../defaults.js";

const drawPartRepeat = (container, data) => {
  const bindingData = [data];

  const path = container.selectAll("path.rpath").data(bindingData);
  path
    .enter()
    .append("path")
    .classed("rpath", true)
    .merge(path)
    .attr("d", () => {
      // Starting point
      const startX = defaultWidth / 2;
      const startY = -defaultHeight / 2;

      // Vertical line down to start curve
      const verticalEndY = 0;

      // Control points for cubic bezier curve to create the curve to the right
      // Adjust these points to control the shape of the curve
      const cp1X = startX; // First control point - same x as starting point to go down vertically
      const cp1Y = verticalEndY + 2; // Move the first control point down a bit to start the curve
      const cp2X = startX + 5; // Second control point - move to the right to create the horizontal end
      const cp2Y = verticalEndY + 5; // Adjust the y to control the curve's height
      const endX = startX + 34; // End point x - to the right of the start
      const endY = verticalEndY + 5; // End point y - same y as vertical end to finish horizontally

      // Construct the path string
      return `M${startX},${startY} V${verticalEndY} 
              C${cp1X},${cp1Y} ${cp2X},${cp2Y} 
               ${endX},${endY}`;
    });
  path.exit().remove();

  drawPartRepeatReturnState(container, data);
};

const drawPartRepeatReturnState = (container, data) => {
  const bindingData = [data];
  const path = container.selectAll("path.retpath").data(bindingData);
  path
    .enter()
    .append("path")
    .classed("retpath", true)
    .merge(path)
    .attr("data-class", "part-repeat-return")
    .attr("d", (d) => {
      // Starting point
      const startX = 30 + defaultWidth;
      // Control points for cubic bezier curve to create the curve to the left
      const startY = d.size.height;
      const endX = d.position.x + defaultWidth * 2; // End point x - to the left of the start

      // Construct the path string
      return `M${startX},${startY}  
              c${0}, ${0} 
               ${-endX}, ${5} 
               ${-endX}, ${20}`;
    });
  path.exit().remove();
};

export { drawPartRepeat };
